import { Checkbox, FormControlLabel } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Alert, AlertTitle } from '@material-ui/lab';
import React from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const RvpAlert = () => {
  const [checkBoxState, setCheckBoxState] = React.useState(false);
  const [alert, setShowAlert] = React.useState(false);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  React.useEffect(() => {
    const rvpResponseLocalStorage = JSON.parse(localStorage.getItem('show_rvp_message'));

    if (!rvpResponseLocalStorage) setShowAlert(true);
  }, []);

  function handleChangeRvpMessageState(e: React.ChangeEvent<HTMLInputElement>) {
    setCheckBoxState(e.target.checked);
  }

  function handleCloseAlert() {
    localStorage.setItem('show_rvp_message', `${checkBoxState}`);
    setShowAlert(false);
  }

  if (!user?.producer || !alert) return null;

  return (
    <>
      <Alert severity='info'>
        <AlertTitle>Recuperação de vendas perdidas (RVP) com taxa zero!</AlertTitle>
        <p>
          A RVP está disponível sem taxa e você pode aproveitar sem se preocupar com pagamento adicional. Além disso, no mês de maio a RVP estará
          disponível para todos os tipos de produtos com vendas feitas via <strong>cartão de crédito, pix e boleto.</strong>
        </p>
        <p>
          Em decorrência dessas melhorias, criamos novos e-mails com uma comunicação focada em recuperar vendas com pagamento via pix e cartão, além
          de boleto. Por isso, <strong>esteja atento às personalizações nos e-mails da RVP</strong>, pois precisarão ser refeitas para se adequarem
          aos novos modelos!
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 12 }}>
          <FormControlLabel label='Não mostrar novamente' control={<Checkbox size='small' onChange={handleChangeRvpMessageState} />} />
          <Button variant='outlined' color='secondary' onClick={handleCloseAlert}>
            Entendi
          </Button>
        </div>
      </Alert>
      <div className='m16' />
    </>
  );
};

export default RvpAlert;
